import React from "react";
import { Link } from "@quintype/components";
import { string, bool } from "prop-types";

import "./excerpt.m.css";

const Excerpt = ({ excerpt = "", excerptLink = "", linkEnable = true }) => {
  return (
    excerpt && (
      <p styleName="excerpt" className="excerpt">
        {linkEnable ? (
          <Link aria-label={excerpt} href={excerptLink}>
            {excerpt}
          </Link>
        ) : (
          <span>{excerpt}</span>
        )}
      </p>
    )
  );
};

Excerpt.propTypes = {
  excerpt: string,
  excerptLink: string,
  linkEnable: bool,
};

export default Excerpt;
